import { MenuEntry } from '@padiswap/uikit'

const config: MenuEntry[] = [
  {
    label: 'Network (Mainnet)',
    icon: 'HomeIcon',
    items: [      
      {
        label: '> Binance (BSC)',
        href: 'https://app.padiswap.com',
      },
      {
        label: '> Celo - (CELO)',
        href: 'https://celo.padiswap.com',
      },
      {
        label: '> Polygon (Matic)',
        href: 'https://polygon.padiswap.com',
      },   
      {
        label: '> Fantom (FTM)',
        href: 'https://ftm.padiswap.com',
      },
      {
        label: '> Harmony (ONE)',
        href: 'https://one.padiswap.com',
      },
      {
        label: '> Velas (VLX)',
        href: 'https://velas.padiswap.com',
      },   
      {
        label: '> HPB Network (HPB)',
        href: 'https://hpb.padiswap.com',
      },      
    ],
  },  
  {
    label: "Trade",
    icon: "TradeIcon",
    items: [
      {
        label: "Exchange",
        href: "/swap",
      },
      {
        label: "Liquidity",
        href: "/pool",
      },
    ],
  },  
  {
    label: "Info (soon)",
    icon: "InfoIcon",
    href: "",
  }, 
  {
    label: "Farms (soon)",
    icon: "FarmIcon",
    href: "",
  },  
  {
    label: 'More',
    icon: 'MoreIcon',
    items: [        
      {
        label: 'Airdrop',
        href: 'https://airdrop.padiswap.com',
      },   
      {
        label: 'Disperse',
        href: 'https://disperse-rei.padiswap.com',
      },  
      {
        label: 'Faucet',
        href: 'https://kururu.finance/faucet?chainId=55555',
      },   
      {
        label: 'Github',
        href: 'https://github.com/padiswap',
      },
      {
        label: 'Medium',
        href: 'https://medium.com/@padiswap',
      },
      {
        label: 'Facebook',
        href: 'https://facebook.com/padiswap',
      },
      {
        label: 'Watcher',
        href: 'https://watcher.guru/coin/padi-swap',
      },
      {
        label: 'Dappradar',
        href: 'https://dappradar.com/binance-smart-chain/defi/padiswap',
      },
      {
        label: 'Add Token',
        href: 'https://t.me/maksubasi',
      },    
    ],
  },
]

export default config